<template>
  <div class="big-box">
    <div class="scroll-box">
      <img
        class="layout-img"
        src="https://cdn-image.yucrm.cn/images/dyAssets/images/preview/layout2.png"
        alt=""
      />
      <img :src="backgroundImage" alt="" class="big-box-img" />
      <div class="big-body">
        <!-- <img :src="tapTopUrl" alt="" class="tap-top" /> -->
        <div class="pd8">
          <!-- 主题文字 -->
          <div
            class="theme-word"
            :style="`color: ${customerPaperwork.titleColor};`"
          >
            <div class="title">{{ customerPaperwork.title }}</div>
            <div class="desc">{{ customerPaperwork.desc }}</div>
          </div>
          <div
            :class="[
              'nav-box',
              { 'flex-c': navList.length <= 4, 'flex-box': navList.length > 4 },
            ]"
            :style="navStyle"
          >
            <div
              v-for="(item, index) in navList"
              :key="item.firstText"
              class="nav-item"
              :style="currentIndex === index ? selectStyle : ''"
              @click="handleChange(index)"
            >
              <div>{{ item.firstText }}</div>
              <div
                class="nav-item_desc"
                v-if="(item.rankStart && item.rankEnd) || item.rankNum"
              >
                {{ item.secondText }}
              </div>
            </div>
          </div>
          <div class="prize-box">
            <img v-if="currentPrize.logo" :src="currentPrize.logo" alt="" />
            <div class="title">{{ currentPrize.title }}</div>
          </div>
          <div></div>
        </div>
      </div>
      <div class="main-btn" v-if="btnUrl">
        <img :src="btnUrl" alt=""/>
        <div class="btn-word" :style="`color: ${customerPaperwork.btnColor};`">
          立即报名
        </div>
        <img
          class="bargain-btn-icon"
          src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/preview/sweep-light.svg"
          alt=""
        />
      </div>
    </div>
    <div class="footer-title">图为预览效果，以实际投效果为准</div>
  </div>
</template>
<script>
export default {
  name: "",
  components: {},
  mixins: [],
  props: {
    ruleForm: {
      type: Object,
      default: () => ({}),
    },
    ruleDTO: {
      type: Object,
      default: () => ({}),
    },
    customerPaperwork: {
      type: Object,
      default: () => ({}),
    },
    templateObj: {
      type: Object,
      default: () => ({}),
    },
    backgroundImage: {
      type: String,
      default: "",
    },
    productList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentIndex: 0,
      currentObj: {},
      currentPrize: [],
      prizeList: [],
      tapTopUrl:
        "https://cdn-image.yucrm.cn/images/dyAssets/images/preview/shop_top.png",
    };
  },
  computed: {
    tabUrl() {
      return this.customerPaperwork.tabUrl
        ? this.customerPaperwork.tabUrl
        : this.templateObj.url3;
    },
    btnUrl() {
      return this.customerPaperwork.url3
        ? this.customerPaperwork.url3
        : this.templateObj.url3;
    },
    navList() {
      const sortType = {
        0: "一",
        1: "二",
        2: "三",
        3: "四",
        4: "五",
        5: "六",
        6: "七",
        7: "八",
        8: "九",
        9: "十",
        10: "十一",
        11: "十二",
        12: "十三",
        13: "十四",
        14: "十五",
        15: "十六",
        16: "十七",
        17: "十八",
        18: "十九",
        19: "二十",
      };
      return this.productList.map((item, index) => {
        let obj = {
          rankStart: item.scoreRankWinConditionDTO.rankStart,
          rankEnd: item.scoreRankWinConditionDTO.rankEnd,
          rankNum: item.scoreRankWinConditionDTO.rankNum,
          firstText: `${sortType[index]}等奖`,
          secondText:
            item.scoreRankWinConditionDTO.winType == 0
              ? `TOP${item.scoreRankWinConditionDTO.rankStart}-${item.scoreRankWinConditionDTO.rankEnd}`
              : ` TOP${item.scoreRankWinConditionDTO.rankNum}`,
        };
        return obj;
      });
    },
    selectUrl() {
      return this.customerPaperwork.url2
        ? this.customerPaperwork.url2
        : this.templateObj.url2;
    },
    selectStyle() {
      return `background: url(${this.selectUrl}); no-repeat;background-size: 65px 26px;color:${this.customerPaperwork.selectColor};`;
    },
    navStyle() {
      return `background: ${this.hexToRgba(
        this.customerPaperwork.unSelectBgColor,
        this.customerPaperwork.navOpacity
      )};color:${this.customerPaperwork.unSelectColor};`;
    },
  },
  watch: {
    productList: {
      handler(newVal, oldVal) {
        this.currentPrize = newVal[this.currentIndex];
      },
      deep: true,
    },
  },
  mounted() {},
  methods: {
    handleChange(index) {
      this.currentIndex = index;
      this.currentPrize = this.productList[index];
    },
    // 将十六进制颜色转换为rgba格式，支持透明度设置，透明度不影响子元素
    hexToRgba(hex, opacity) {
      if (!hex) return "rgba(255,255,255,1)";
      // 处理简写形式 #fff => #ffffff
      let color = hex.replace("#", "");
      if (color.length === 3) {
        color = color[0] + color[0] + color[1] + color[1] + color[2] + color[2];
      }
      const r = parseInt(color.substring(0, 2), 16);
      const g = parseInt(color.substring(2, 4), 16);
      const b = parseInt(color.substring(4, 6), 16);
      const a = opacity / 100;
      return `rgba(${r}, ${g}, ${b}, ${a})`;
    },
  },
};
</script>
<style lang="scss" scoped>
.big-box {
  position: relative;
  width: 300px;
  height: 580px;
  box-shadow: 0px 4px 20px 0px rgba(18, 10, 60, 0.15);
  border-radius: 24px;
  border: 1px solid #ffffff;
  padding: 8px;
  margin-left: 231px;
  z-index: 999;
  background-color: #ffffff;

  .scroll-box {
    position: relative;
    width: 284px;
    height: 560px;
    overflow: hidden;
    border-radius: 24px;
    .layout-img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
  .big-box-img {
    border-radius: 24px;
    width: 100%;
  }
  .big-body {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .tap-top {
      width: 100%;
    }
    .pd8 {
      position: absolute;
      top: 88px;
      width: 100%;
      height: 100%;
      // margin-top: 18px;
      // padding: 8px;
      box-sizing: border-box;
      position: relative;
      .theme-word {
        // position: absolute;
        display: flex;
        flex-direction: column;
        align-items: center;
        // top: 18px;
        width: 100%;
        > div:first-child {
          height: 16px;
          font-weight: bold;
          font-size: 15px;
          margin-bottom: 10px;
        }
        > div:last-child {
          margin: 0 auto;
          text-align: center;
          width: 65%;
          height: 11px;
          line-height: 12px;
          font-size: 11px;
          opacity: 0.7;
        }
      }
      .nav-box {
        position: relative;
        margin: 14px auto;
        width: 248px;
        height: 30px;
        border-radius: 50px 50px 50px 50px;
        overflow-y: hidden;
        overflow-x: auto;
        cursor: pointer;
        &::-webkit-scrollbar {
          width: 2px;
          height: 2px;
        }
        .nav-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 65px;
          height: 26px;
          flex-shrink: 0;
          font-size: 9px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          &_desc {
            padding: 0 3px;
            width: 100%;
            opacity: 0.5;
            margin-top: 2px;
            font-size: 8px;
            text-align: center;
            // 一行展示
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
      .flex-c {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .flex-box {
        display: flex;
        align-items: center;
      }
      .prize-box {
        margin: 16px auto;
        width: 114px;
        height: 151px;
        padding: 5px;
        background: #ffffff;
        box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.06);
        border-radius: 12px;
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          width: 107px;
          height: 107px;
          border-radius: 12px;
          object-fit: cover;
        }
        .title {
          margin-top: 9px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 12px;
          line-height: 12px;
          color: #1a1a1a;
          text-align: center;
          font-style: normal;
          text-transform: none;
        }
      }
    }
  }
  .main-btn {
    position: sticky;
    left: 13%;
    bottom: 14px;
    width: 219px;
    height: 37px;
    // background: #ffffff;
    border-radius: 25px;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .btn-word {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-family: PingFang SC, PingFang SC;
      font-weight: 600;
      font-size: 12px;
      color: #ffffff;
      line-height: 12px;
      text-align: center;
      font-style: normal;
      text-transform: none;
    }
    .bargain-btn-icon {
      width: 215px;
      height: 32px;
      position: absolute;
      left: 0;
      bottom: 0;
      animation: identifier 2s infinite;
      border-radius: 19px 19px 19px 19px;
    }
    @keyframes identifier {
      0% {
        transform: translateX(-30px);
      }
      100% {
        transform: translateX(100%);
      }
    }
  }
  .footer-title {
    margin-top: 20px;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 14px;
    text-align: center;
  }
}
</style>
